module.exports = __webpack_public_path__ + "img/0-sm.15bb1197.jpg";